/**
 * ModuleService encapsulates helper method that determine whether a module is allowed for a given study version.
 */
export const moduleService = {
	isModuleRNRAllowed: (version, studyType) => __isModuleRNRAllowed(version, studyType),
	isModuleSleepAllowed: (version) => __isModuleSleepAllowed(version),
	isModuleSupplementsAllowed: (version) => __isModuleSupplementsAllowed(version)
};

/**
 * All versions except Australian (14 and 19) are allowed to use the RNR.
 * @param {int} version - The version of the study.
 * @param {string} studyType - The type of the study. Not the study tool. For example, "CONSECUTIVE_DAY", "SINGLE_DAY", "SCHEDULED", "UNSCHEDULED".
 * @returns {Object} - An object with two flags. isModuleAllowed is true if the study version is allowed use the RNR. isFollowupAllowed is true if the study type supports turning the RNR on/off for the user to see.
 */
function __isModuleRNRAllowed (version, studyType) {
	const isAllowed = {
		isModuleAllowed: version !== 14 && version !== 19,
		isFollowupAllowed: studyType !== 'CONSECUTIVE_DAY' && studyType !== 'SINGLE_DAY'
	};

	return isAllowed;
}

/**
 * Sleep module is allowed only for US versions. Currently versions 21, 23, 25 support it.
 * @param {int} version - The version of the study.
 * @returns {boolean} - True if the study is allowed to use the sleep module.
 */
function __isModuleSleepAllowed (version) {
	return version === 21 || version === 23 || version === 25;
}

/**
 * Supplements is allowed for older versions where supplements were optional. Going forward supplements are always on.
 * @param {int} version - The version of the study.
 * @returns {boolean} - True if the study is allowed to use the supplements module.
 */
function __isModuleSupplementsAllowed (version) {
	return version < 23;
}
